module.exports = __webpack_public_path__ + "461e7554e8c13637166d8eab1f77739a.fbx";